<template>
  <el-select
    :clearable="clearable"
    :disabled="disabled"
    filterable
    :value="value"
    @change="changeHandle"
  >
    <el-option
      v-for="(item, index) in areaList"
      :key="index"
      :value="item.id"
      :label="item.areaName"
    ></el-option>
  </el-select>
</template>

<script>
import areaMixin from './mixin.js';
import { Select } from 'element-ui';

export default {
  name: 'area-select',
  props: {
    size: String,
    value: Number,
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [areaMixin],
  methods: {
    changeHandle(val) {
      if (val) {
        this.$emit('input', val);
        this.$emit('change', val);
      } else {
        this.$emit('input', null);
        this.$emit('change', null);
      }
    },
  },
};
</script>

